export default __webpack_public_path__ + "static/media/tPro3.20626e3c.jpg";